module.exports = __webpack_public_path__ + "img/Millennium.e0dd34c2.png";